import React, { Fragment, useEffect, useState } from 'react'
import Modal from 'components/shared/modals/Modal'
import clsx from 'clsx'
import Loader from 'components/shared/Loader/Loader'
import useGetAllTradingPlatforms from 'sdk/hooks/trading/useGetAllTradingPlatforms'
import { ReactComponent as IconArrowDown } from 'images/arrow-down-w.svg';
import { ReactComponent as IconPros } from 'images/icons/pros.svg';
import { ReactComponent as IconCons } from 'images/icons/cons.svg';
import usePost from 'sdk/hooks/usePost'
import { useNavigate } from 'react-router-dom'
import { SelectWithIcon } from 'components/shared/Select'
import BackBtn from 'components/shared/BackBtn'
import styles from './CompareTradingModal.module.scss' // eslint-disable-line

type Props = {
  isOpen: boolean
  onClose: () => void
  onBack?: () => void
}

export default function CompareTradingModal({
  isOpen,
  onClose,
  onBack,
}: Props) {
  const { data: tradingPlatforms, isFetching } = useGetAllTradingPlatforms()
  const [platforms, setPlatforms] = useState<any[]>([])
  const [compare1, setCompare1] = useState<any>()
  const [compare2, setCompare2] = useState<any>()
  const { data: compare1Post } = usePost(compare1?.post_id)
  const { data: compare2Post } = usePost(compare2?.post_id)
  const navigate = useNavigate()

  useEffect(() => {
    if (tradingPlatforms) {
      setPlatforms(tradingPlatforms.map((el) => ({
        ...el,
        isActive: false,
        value: el.id,
        label: el.name,
        icon: el.logo,
      })))
    }
  }, [tradingPlatforms])

  useEffect(() => {
    if (compare1 || compare2) {
      setPlatforms((prevPlatforms) => prevPlatforms.map((p) => ({
        ...p,
        isActive: p.logo === compare1?.logo || p.logo === compare2?.logo,
      })));
    }
  }, [compare1, compare2]);

  const toggle = (id: number) => {
    const newList = platforms.map((el) => {
      if (el.id === id) {
        return { ...el, isActive: !el.isActive }
      }
      return el
    })

    setPlatforms(newList)
  }

  const tradeList = (
    <div>
      {
        isFetching ? (
          <Loader />
        ) : (
          <div className={styles.trades}>
            {
              platforms?.map((trade) => (trade?.active ? (
                <React.Fragment key={trade.id}>
                  <div
                    className={clsx(styles.trade, trade.isActive && styles.active)}
                    key={trade.id}
                    onClick={() => toggle(trade.id)}
                  >
                    <img src={trade.logo} alt={trade.name} />
                    {trade.name}
                    <IconArrowDown />
                  </div>
                  {
                    trade.isActive && (
                      <div className={styles.content}>
                        {trade.pros.split('- ').map((pro) => (
                          pro ? (
                            <div key={pro} className={styles.pros}>
                              <IconPros />
                              {pro}
                            </div>
                          ) : ''
                        ))}
                        <div>
                          {trade.cons.split('- ').map((con) => (
                            con ? (
                              <div key={con} className={styles.cons}>
                                <IconCons />
                                {con}
                              </div>
                            ) : ''
                          ))}
                        </div>
                      </div>
                    )
                  }
                </React.Fragment>
              ) : null))
            }
          </div>
        )
      }
    </div>
  )

  const toText = (string: string) => {
    const paragraphs = string.split('- ').filter((item) => item !== '')

    return (
      <>
        {paragraphs.map((paragraph) => (
          <p>{`- ${paragraph}`}</p>
        ))}
      </>
    );
  }

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      onClick={(e: any) => e.stopPropagation()}
      className={clsx(styles.modal, 'scroll')}
    >
      {onBack ? (
        <BackBtn
          className={styles.btnBack}
          onClick={onBack}
        />
      ) : null}
      <h2 className={styles.title}>Сompare</h2>
      <div className={styles.selects}>
        <SelectWithIcon
          options={platforms.filter((p) => (p.id !== compare2?.id && p.active))}
          value={compare1}
          onChange={(e: any) => setCompare1(e)}
          optionClassName={styles.compareSelectOption}
          secondary
        />
        <SelectWithIcon
          options={platforms.filter((p) => (p.id !== compare1?.id && p.active))}
          value={compare2}
          onChange={(e: any) => setCompare2(e)}
          optionClassName={styles.compareSelectOption}
          secondary
        />
      </div>
      {
          (compare1 && (compare1 === compare2)) && (
            <span className={styles.error}>You can not compare 2 identical platforms</span>
          )
        }
      {
          (compare1 && compare2 && (compare1 !== compare2)) && (
            <>
              <div className={styles.comaprePros}>
                <div className={styles.comaprePro}>
                  <div className={styles.comapreProTitle}>
                    <IconPros />
                    Pros
                  </div>
                  {toText(compare1.pros)}
                </div>
                <div className={styles.comaprePro}>
                  <div className={styles.comapreProTitle}>
                    <IconPros />
                    Pros
                  </div>
                  {toText(compare2.pros)}
                </div>
              </div>
              <div className={styles.comapreCons}>
                <div className={styles.comapreCon}>
                  <div className={styles.comapreConTitle}>
                    <IconCons />
                    Cons
                  </div>
                  {toText(compare1.pros)}
                </div>
                <div className={styles.comapreCon}>
                  <div className={styles.comapreConTitle}>
                    <IconCons />
                    Cons
                  </div>
                  {toText(compare2.pros)}
                </div>
              </div>
              <div className={styles.comapreImgs}>
                <div>
                  <span>
                    <video
                      src={compare1Post?.video_link}
                      onMouseEnter={(e: any) => e.target.play()}
                      onMouseLeave={(e: any) => e.target.pause()}
                      onClick={() => navigate('/tradingPlatforms')}
                    />

                  </span>
                </div>
                <div>
                  <span>
                    <video
                      src={compare2Post?.video_link}
                      onMouseEnter={(e: any) => e.target.play()}
                      onMouseLeave={(e: any) => e.target.pause()}
                      onClick={() => navigate('/tradingPlatforms')}
                    />

                  </span>
                </div>
              </div>
            </>
          )
        }
      {tradeList}
    </Modal>
  )
}
